/**
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 **/
import i18nClient from '@userzoomplatform/pe-i18n';

import config from './config';
import { areCookiesEnabled } from './cookies';

export const Namespaces = {
	Common: 'common',
	Legal: 'legal',
	Pscl: 'pscl',
	Desktop: 'desktop',
};

const isProduction = process.env.NODE_ENV === 'production';
const { translationsVersion } = config();

// development output directories are defined in bin/mount-translations.js
const translationsPath = isProduction
	? `${process.env.REACT_APP_TRANSLATIONS_URL}/${translationsVersion}/{{lng}}/{{ns}}.json`
	: `${process.env.PUBLIC_URL}/translations/participant-experience/{{lng}}/{{ns}}.json`;

const legalTranslationsPath = isProduction
	? `${process.env.REACT_APP_LEGAL_TRANSLATIONS_URL}/{{lng}}/{{ns}}.json`
	: `${process.env.PUBLIC_URL}/translations/legal-texts/{{lng}}/{{ns}}.json`;

export default i18nClient({
	namespaces: Object.values(Namespaces),
	defaultNamespace: Namespaces.Common,
	translationsPath,
	legalTranslationsPath,
	translationsVersion,
	localStorageAvailable: areCookiesEnabled(),
	cache: { prefix: 'pe-ui' },
	isProduction,
});
